let timer = null; // 声明计时器
const debounce = (fn, delay = 200) => {
  return function () {
    const context = this;
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
// 上一次执⾏行行该函数的时间
let lastTime = 0;
export const throttle = (func, wait = 200) => {
  return function (...args) {
    const now = +new Date(); // 当前时间
    // 将当前时间和上⼀一次执⾏行行函数时间对⽐比
    // 如果差值⼤大于设置的等待时间就执⾏行行函数
    if (now - lastTime > wait) {
      lastTime = now;
      func.apply(this, args);
    }
  };
};
const throttleNew = (func, wait = 200) => {
  return function (...args) {
    const now = +new Date(); // 当前时间
    // 将当前时间和上⼀一次执⾏行行函数时间对⽐比
    // 如果差值⼤大于设置的等待时间就执⾏行行函数
    if (!func.lastTime) {
      func.lastTime = 0;
    }
    if (now - func.lastTime > wait) {
      func.lastTime = now;
      func.apply(this, args);
    }
  };
};
const throttleAt = (obj, func, wait = 200, failedCallback) => {
  return function (...args) {
    const now = +new Date(); // 当前时间
    // 将当前时间和上⼀一次执⾏行行函数时间对⽐比
    // 如果差值⼤大于设置的等待时间就执⾏行行函数
    if (!obj.throttleLastTime) {
      obj.throttleLastTime = 0;
    }
    if (now - obj.throttleLastTime > wait) {
      obj.throttleLastTime = now;
      func.apply(this, args);
    } else {
      failedCallback.apply(this, args);
    }
  };
};
module.exports = {
  debounce: debounce,
  throttle: throttle,
  throttleNew: throttleNew,
  throttleAt: throttleAt,
};
